export enum FilterType {
  CAPACITY = 'capacity',
  OFFICE_TYPE = 'office_type',
  LOCATION = 'location',
  BUDGET = 'budget',
  SURFACE = 'surface',
  OTHER_FILTERS = 'other_filters',
}

export enum OtherFiltersType {
  TRANSPORTS = 'transports',
  ACCESSIBILITY = 'accessibility',
  IDEAL_LOCATION = 'ideal_location',
  SERVICES = 'services',
  LIGHT = 'light',
  CONTRACT_TYPE = 'contract_type',
}
